import { ROUTES } from '@/config/routes';
import type { SidebarNavItem } from './Sidebar';

/** Navigation when the Core workspace is off. `ROUTES.projects` hosts the models tree slot. */
export const DEFAULT_NAV_ITEMS: readonly SidebarNavItem[] = [
  { label: 'Dashboard', path: ROUTES.dashboard, icon: 'dashboard', section: 'Workspace' },
  { label: 'Projects', path: ROUTES.projects, icon: 'projects' },
  { label: 'Snapshots', path: ROUTES.snapshots, icon: 'snapshots' },
  { label: 'Audits', path: ROUTES.audits, icon: 'audits' },
  { label: 'Families library', path: ROUTES.families, icon: 'families' },
];
